module.exports = __webpack_public_path__ + "img/appBar.3103f543.png";